import React, {useState, useEffect, useRef, useContext} from 'react';
import {
    Container,
    Button,
    Box,
    Typography,
    Tab,
    Tabs,
    Avatar,
    ListItemSecondaryAction,
    Menu,
    MenuItem,
    TextField, Tooltip
} from '@mui/material';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
    MoreVert,
    Chat as ChatIcon,
    Settings,
    PostAdd,
    InsertDriveFile,
    ImportExport,
    AddToHomeScreen, Notifications, LockPersonOutlined, Source, DnsOutlined, Storage, DeveloperMode
} from "@mui/icons-material";
import {useNavigate, useLocation} from 'react-router-dom';
import {getEmail, getKB, saveKB, updateSearchSettings} from "../API/KB/KBAPI.js";
import ImportPagesPopup from "../Item/Import/ImportPagesPopup.js";
import {
    generatePassphrase,
    generateKey,
    encrypt,
    setKBKey,
    getKBKey,
    encryptKBItem,
    decryptKBItem, decryptKBItemIfEncrypted
} from '../App/cryptoUtils.js';
import {useParams} from 'react-router-dom';
import {mobileButton, colorText, colorIcon, colorTextInactive} from "../App/theme.js";
import Loader from "../Loaders/LocalLoader.js";
import List from "../Item/list.js";
import {invalidateKBImageCache, KBImageComponent} from "./KBImage.js";
import {KeyBackupAlert} from "../Alerts/KeyBackup.js";
import ChatSettings from "../Chat/ChatSettings.js";
import {Chat} from "../Chat/Chat.js";
import {AccessControl} from "./AccessControl.js";
import {is_on_premises, isMobile, navigateKBSubdomain} from "../App/utils.js";
import {BackButton} from "./BackButton.js";
import {AlertContext, APIContext} from "../App/App.js";
import {CodeEditor} from "../Code/CodeEditor.js";
import {ChatModels, EmbeddingDimensions, EmbeddingModels} from '../constants.js';
import {KB_TABS} from "../App/constants";
import {isMac, isSharedApp} from "../utils";
import {KBName} from "../names";
import {PaperWrapper} from "../Components/PaperWrapper";
import {backButtonMt, buttonVerticalMargin, subtitleMarginBottom, subtitleMarginTop} from "../App/style";
import {getContentRenderURL} from "../Chat/utils";
import {InstallPWAButton} from "../PWA/InstallPWAButton";
import {handleSubscribePushNotifications} from "../PWA/EnableNotificationsButton";
import {getChat, updateChat} from "../API/chatAPI";
import {Whitescreen} from "../App/Whitescreen";

const MAX_IMG_SIZE = 2 * 1024 * 1024;
const KBForm = ({open, setKBKeyIsSet, network, userProfile, kbIdAsSubdomain, chatId, navigateToChat,
    kbChats, setKBChats, isStreaming, setIsStreaming, unreadMessages, setUnreadMessages, newKB,
    renderSettings, setRenderSettings, ChatData, setChatData

}) => {
    const queryParams = new URLSearchParams(window.location.search);
    const kbIdAsParam = useParams().kbId;
    const kbIdToEdit = kbIdAsSubdomain || kbIdAsParam;
    const [kbIdToEditLoaded, setKbIdToEditLoaded] = useState(false);  
    const [passphrase, setPassphrase] = useState('');
    const [buildInBackup, setBuildInBackup] = useState(true);
    const [hasBackedUpDone, setBackedUpDone] = useState(true);
    const {systemAlert, setSystemAlert} = useContext(AlertContext);

    const [isLoadingBlocking, setIsLoadingBlocking] = useState(false);
    const [kbId, setKBId] = useState(kbIdToEdit);
    const [fileData, setFileData] = useState([]);
    const [activeTab, setActiveTab] = useState(queryParams.get('tab')
        ? queryParams.get('tab')
        : (kbIdToEdit ? KB_TABS.chat : KB_TABS.configuration));
    const [importOpen, setImportOpen] = useState(false);

    const [sharedBy, setSharedBy] = useState('');
    const [isMenuOpened, setMenuOpened] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const {APIData, setAPIData} = useContext(APIContext);

    const buttonSubmitRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();

    const [embeddingModel, setEmbeddingModel] = useState(null);
    const [embeddingDimension, setEmbeddingDimension] = useState(null);
    const [searchEngine, setSearchEngine] = useState(null);
    const [searchSettingsHasChanges, setSearchSettingsHasChanges] = useState(false);
    const [contentRenderLoaded, setContentRenderLoaded] = useState(null);
    const [dynamicRenderLoaded, setDynamicRenderLoaded] = useState(false);
    const [isPWA, setIsPWA] = useState(false);
    const [installPrompt, setInstallPrompt] = useState(null);
    const [notificationsPermissionStatus, setNotificationsPermissionStatus] = useState(false);

    useEffect(() => {
        if (!window?.Notification) {
            setNotificationsPermissionStatus('notsupported')
            return;
        }
        if (window?.Notification?.permission === "granted" || window?.Notification?.permission === "denied") {
            setNotificationsPermissionStatus(window.Notification.permission)
        } else {
            setNotificationsPermissionStatus(null)
        }
    }, []);


    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setInstallPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // Check if the app is running as a PWA
        const checkIfPWA = () => {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            if (document.referrer.startsWith('android-app://') || isStandalone) {
                setIsPWA(true);
            }
        };

        checkIfPWA();

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    useEffect(() => {
        const currentTabURL = new URLSearchParams(location.search).get('tab');

        if (currentTabURL && currentTabURL !== activeTab) {
            setActiveTabWrapper(currentTabURL);
        } else if (currentTabURL === null && activeTab !== KB_TABS.chat) {
            setActiveTabWrapper(KB_TABS.chat);
        }
    }, [location]);

    useEffect(() => {
        return () => {
            setAPIData({});
        };
    }, []);

    useEffect(() => {
        if (
            embeddingModel && embeddingModel !== 'none' && ( embeddingDimension === 'none' ||  embeddingDimension >  EmbeddingModels[embeddingModel].dimension)
        ) {
            setEmbeddingDimension(EmbeddingModels[embeddingModel].dimension);
        }
    }, [embeddingModel, embeddingDimension]);

    const defaultModel = Object.keys(ChatModels).find(o => ChatModels[o].default);

    const chatSettingsInit = {
        inputTools: [
            // "imageToText"
        ],
        chatVendor: ChatModels[defaultModel].vendor,
        model: defaultModel,
        OpenAIAPIKey: '',
        voiceId: '',
    };

    const videoSettingsInit = {
        videoVendor: '',
        videoVoiceId: '',
    };

    // KB Form
    const [KBData, setKBData] = useState({
        kbTitle: '',
        kbDescription: '',
        kbInstructions: '',
        ...chatSettingsInit,
        ...videoSettingsInit,        
        key: ''
    });

    function setActiveTabWrapper(value) {
        fetchKB()
        setActiveTab(value);
    }

    const handleFileUpload = (e) => {
        if (!e.target.files) {
            return;
        }
        const file = e.target.files[0];
        if (file.size > MAX_IMG_SIZE) {
            setSystemAlert({ msg : `Image size should not exceed ${MAX_IMG_SIZE/(1024*1024)}MB`, type: 'error'});
            // Clear the selected file
            e.target.value = null;
            return;
        }


        const reader = new FileReader();
        reader.onload = (evt) => {
            if (!evt?.target?.result) {
                return;
            }
            const {result} = evt.target;
            setFileData(result);
            if (kbId) handleUpdateCreateKB(e, result);
            invalidateKBImageCache();
        };

        reader.readAsDataURL(file);
    };

    const fetchKB = async () => {
        const response = await getKB();

        if (!response) return;

        let {createdAt,updatedAt,userId, ...KB} = response;


        if (KB?.embeddingModel) setEmbeddingModel(KB?.embeddingModel)
        if (KB?.embeddingDimension) setEmbeddingDimension(KB?.embeddingDimension)
        if (KB?.searchEngine) setSearchEngine(KB?.searchEngine)

        // setSharedBy if shared
        if (isSharedApp) {
            const { email } = await getEmail();
            setSharedBy(email);
        }

        setKBData(KB);
        setAPIData((prev) => ({...prev, KBData: KB}));
        setIsLoadingBlocking(false);
        setKbIdToEditLoaded(true)
    }

    useEffect(  () => {
        if (!kbId) {
            // Before Create
            setPassphrase(generatePassphrase());
        } else {
            setIsLoadingBlocking(true);
            fetchKB();
        }
    }, []);

    const handleUpdateCreateKB = async (e, myfileData) => {
        e.preventDefault();
        if (hasBackedUpDone || kbId) {
            try {
                const action = kbId ? 'update' : 'create';
                const key = kbId ? getKBKey(kbId)  : generateKey(passphrase);
                const encryptedTitle = encrypt(KBData.kbTitle, key);
                const encryptedDescription = encrypt(KBData.kbDescription, key);
                const encryptedInstructions = encrypt(KBData.kbInstructions, key);
                const accountId = userProfile.accountId;
                const encryptedWalletPrivateKey = encrypt(userProfile.walletPrivateKey, key);
                const walletPublicKey = userProfile.walletPublicKey;

                setIsLoadingBlocking(true);

                const promises = [];

                // Add the saveKB promise
                const saveKBPromise = saveKB({
                    action: action,
                    kbTitle: encryptedTitle,
                    pwaName: KBData.kbTitle, // pass name for PWA (for now just plain text kbTitle)
                    kbDescription: encryptedDescription,
                    kbInstructions: encryptedInstructions,
                    chatVendor: KBData?.chatVendor || ChatModels?.[KBData?.model].vendor,
                    chatEndpoint: ChatModels?.[KBData?.model]?.chatEndpoint,
                    model: KBData.model,
                    OpenAIAPIKey: (KBData.OpenAIAPIKey ? encrypt(KBData.OpenAIAPIKey, key) : ''),
                    voiceId: KBData.voiceId,
                    videoVendor: KBData.videoVendor,
                    videoVoiceId: KBData.videoVoiceId,
                    key: (buildInBackup ? key : ''),
                    fileData: (myfileData || fileData),
                    inputTools: KBData.inputTools,
                    frontendTokenLimit: KBData.frontendTokenLimit,
                    accountId: accountId,
                    walletPublicKey: walletPublicKey,
                    walletPrivateKey: encryptedWalletPrivateKey
                });

                promises.push(saveKBPromise);

                // Add the updateSearchSettings promise if the condition is met
                if (searchSettingsHasChanges) {
                    promises.push(updateSearchSettings(embeddingModel, embeddingDimension, searchEngine));
                }

                // Execute all promises in parallel and wait for them to complete
                const [res, ...restRes] = await Promise.all(promises);

                setAPIData((prev) => ({...prev, KBData}));

                setIsLoadingBlocking(false);

                // Create new KB
                if (!kbId && key && res?.kbId) {
                    setKBKey(res.kbId, key);
                }

                if (kbId && res) setSystemAlert({ msg: `Changes Saved`, type: 'success', duration: 2000 });

                if (!kbId && res?.kbId) {
                    setKBId(res?.kbId);
                    navigateKBSubdomain(res.kbId);
                }

            } catch (error) {
                setIsLoadingBlocking(false);
                if (error?.response?.data?.error) alert(error.response.data.error);
            } finally {
                setSearchSettingsHasChanges(false);
            }
        } else {
            alert('Please confirm that you have saved the passphrase before saving the kb.');
        }
    };

    useEffect(() => {
        function handleKeyDown(event) {
            if (event.ctrlKey || event.metaKey) {
                switch (String.fromCharCode(event.which).toLowerCase()) {
                    case 's':
                        event.preventDefault();
                        if(buttonSubmitRef.current) buttonSubmitRef.current.click();
                        break;
                }
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (KBData.kbTitle) {
            const defaultTitle = document.title;
            document.title = KBData.kbTitle;
            return () => { document.title = defaultTitle; };
        }
    }, [KBData]);

    useEffect(() => {
        if (!KBData.kbId) return;

        if (window["contentRender"]) {
            setTimeout(() => setDynamicRenderLoaded(true), 1)
            setContentRenderLoaded(() => window["contentRender"])
            return
        }

        const script = document.createElement('script');
        script.src = getContentRenderURL(KBData.kbId);
        script.async = true;

        script.onload = () => {
            setContentRenderLoaded(() => window["contentRender"])
            setTimeout(() => setDynamicRenderLoaded(true), 1)
        };

        script.onerror = (error) => {
            setTimeout(() => setDynamicRenderLoaded(true), 1)
        };

        document.body.appendChild(script);

        return () => {
            if (!window["contentRender"]) document.body.removeChild(script);
        };
    }, [KBData]);

    const handleTabChanged = (event, newValue) => {
        if (newValue.toString() === KB_TABS.code_studio || activeTab === KB_TABS.code_studio) {
            // Perform a full page reload
            window.location.href = `?tab=${encodeURIComponent(newValue.toString())}`;
        } else {
            const goto = newValue.toString() === KB_TABS.chat ? '?' : `?tab=${encodeURIComponent(newValue.toString())}`;
            navigate(goto);
        }

        setMenuOpened(false);
    }

    const embeddingConfigured = (KBData?.embeddingModel && KBData?.embeddingDimension);
    const hasChanges = APIData?.KBData && Object.keys(APIData?.KBData)?.length > 0 && JSON.stringify(KBData) !== JSON.stringify(APIData.KBData) || searchSettingsHasChanges;

    const menuStyleItem = {marginRight: '16px'};
    const menuStyle= {textTransform: 'Capitalize'};
    const tabStyle = {color: colorText, minWidth: 0, textTransform: 'capitalize'};

    const mobileTopRightButtonStyle = {
        position: "fixed",
        top: 90,
        right: 20,
        zIndex: 10,
    }

    return (
        <>
            <Container>
                <Whitescreen open={!dynamicRenderLoaded}/>
                <ImportPagesPopup
                    onClose={() => {
                        navigate(`/?tab=` + KB_TABS.items);
                    }}
                    KB={KBData}
                    importOpen={importOpen}
                    setImportOpen={setImportOpen}
                    kbId={kbId}
                />

                <Loader open={isLoadingBlocking} blocking={true} />

                {/*Back Button*/}
                {isMobile && dynamicRenderLoaded &&
                    <Box mt={backButtonMt} display="flex" justifyContent="space-between" style={{visibility: renderSettings?.disableMobileLeftButton ? 'hidden' : null}}>
                    <BackButton path='/dashboard' backToChat={activeTab !== KB_TABS.chat} setActiveTab={setActiveTab}/>
                </Box>}

                {/*Back Button End*/}

                {/*Tabs*/}
                {!isMobile && kbId && <Tabs
                    style={{marginTop: -50}}
                    value={activeTab}
                    onChange={handleTabChanged}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab style={tabStyle} label={KB_TABS.chat} value={KB_TABS.chat} />
                    <Tab style={tabStyle} label={KB_TABS.configuration} value={KB_TABS.configuration} />
                    {!is_on_premises && <Tab style={tabStyle} label={KB_TABS.code_studio} value={KB_TABS.code_studio} />}
                    {KB_TABS.items && <Tab style={tabStyle} label={KB_TABS.items} value={KB_TABS.items} />}
                    {!is_on_premises && <Tab style={tabStyle} label={KB_TABS.share_access}  value={KB_TABS.share_access} />}
                </Tabs>}
                {/*Tabs End*/}

                {/*Mobile Menu*/}
                {isMobile && kbId && dynamicRenderLoaded && !renderSettings?.disableMobileRightButton && <ListItemSecondaryAction
                    style={mobileTopRightButtonStyle}
                ><Avatar
                    onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setMenuOpened(!isMenuOpened)
                    }}
                    variant="outlined" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)', color: colorIcon }}><MoreVert /></Avatar>
                    <Menu open={isMenuOpened} anchorEl={anchorEl} onClose={() => setMenuOpened(false)}>

                        <MenuItem onClick={(e) => handleTabChanged(e, KB_TABS.chat)}
                                  style={menuStyle} ><ChatIcon style={menuStyleItem} />{KB_TABS.chat}</MenuItem>

                        <MenuItem onClick={(e) => handleTabChanged(e, KB_TABS.configuration)}
                            style={menuStyle} ><Settings style={menuStyleItem} />{KB_TABS.configuration}</MenuItem>

                        {!is_on_premises && <MenuItem onClick={(e) => handleTabChanged(e, KB_TABS.code_studio)}
                            style={menuStyle} ><DeveloperMode style={menuStyleItem} />{KB_TABS.code_studio}</MenuItem>}

                        {KB_TABS.items && <MenuItem onClick={(e) => handleTabChanged(e, KB_TABS.items)}
                            style={menuStyle} ><Storage style={menuStyleItem} />{KB_TABS.items}</MenuItem>}

                        {KB_TABS?.items && <MenuItem onClick={() => {
                            setImportOpen(true);
                            setMenuOpened(false);
                        }} style={menuStyle} ><ImportExport style={menuStyleItem} />Import Web Pages</MenuItem>}

                        {!is_on_premises && <MenuItem onClick={(e) => handleTabChanged(e, KB_TABS.share_access)}
                                  style={menuStyle} ><LockPersonOutlined style={menuStyleItem} />{KB_TABS.share_access}</MenuItem>}

                        {!isPWA &&
                            <MenuItem style={{...menuStyle, backgroundColor: 'transparent'}} >
                                <AddToHomeScreen style={{color: (installPrompt || isMac()) ? undefined : 'gray', ...menuStyleItem}}/>
                                <InstallPWAButton isActive={(installPrompt || isMac())} {...{ KB: KBData, isPWA, installPrompt }} />
                            </MenuItem>
                        }

                        {isPWA && !["granted", "denied", "notsupported", false].includes(notificationsPermissionStatus) &&
                            <MenuItem style={{...menuStyle, backgroundColor: 'transparent'}} >
                                <Notifications style={menuStyleItem} />
                                <span onClick={() => handleSubscribePushNotifications({setNotificationsPermissionStatus})}>
                                    Enable Notifications
                                </span>
                            </MenuItem>}
                    </Menu>
                </ListItemSecondaryAction>}
                {/*Mobile Menu End*/}


                {[KB_TABS.share_access].includes(activeTab) && (
                    <AccessControl
                        kbId={kbId}
                        title={KBData.kbTitle}
                    />
                )}
                {(kbId && activeTab === KB_TABS.code_studio) && <CodeEditor
                    setKBData={setKBData}
                    KBData={KBData}
                    kbId={kbId}
                    withFilesEditor={true}
                    value={KBData.kbInstructions}
                />}


                {((activeTab === KB_TABS.configuration || activeTab === KB_TABS.items && !kbId) &&
                    [KB_TABS.configuration,KB_TABS.items].includes(activeTab) || newKB)

                    && <Box mt={0}> {!kbId && !hasBackedUpDone && (
                    <KeyBackupAlert
                        setBackedUpDone={setBackedUpDone}
                        setBuildInBackup={setBuildInBackup}
                        buildInBackup={buildInBackup}
                        passphrase={passphrase}
                        kbId={kbId}
                    />
                )}
                    {((kbId || hasBackedUpDone && !isMobile) && [KB_TABS.configuration, KB_TABS.items].includes(activeTab) || newKB)
                        && <Box mt={0} display="flex" justifyContent={isMobile ? "center" : "flex-start"} >
                        <Typography variant="h4" style={{
                            color: colorText,
                            marginTop: '16px',
                            fontSize: isMobile ? 24 : undefined
                        }}>{kbId ? KBName + ' Settings': 'Create New ' + KBName}</Typography>
                    </Box>}


                    <Box
                        display="flex"
                        justifyContent={isMobile ? "center" : "flex-start"}
                        style={{ marginBottom: subtitleMarginBottom, marginTop: subtitleMarginTop }}
                    >
                        <Typography variant="subtitle1" style={{ color: colorTextInactive }}>
                            {kbId
                                ? 'Here you can customize chat models, tools, and settings.'
                                : `Initialize your application by configuring chat models, tools, and settings.`}
                        </Typography>
                    </Box>

                    {( (kbId || hasBackedUpDone) && [KB_TABS.configuration, KB_TABS.items].includes(activeTab) || newKB ) && (
                        <form onSubmit={handleUpdateCreateKB}>
                            {(kbId || isMobile) && activeTab === KB_TABS.configuration && <Box mt={4} display="flex" flexWrap="wrap" justifyContent="flex-end">
                                <Button type="submit" variant={'contained'} color="secondary" onClick={handleUpdateCreateKB}
                                        disabled={!KBData?.kbTitle}
                                        style={{...mobileButton, marginBottom: buttonVerticalMargin}}>
                                    {kbId ? 'Save' : 'Create'}
                                </Button>
                            </Box>}

                            <PaperWrapper>
                                <Box mt={0} style={{textAlign: 'left'}}>
                                    <ChatSettings {...{KBData, setKBData, network}} />

                                    {/* START OF EMBEDDINGS */}
                                    {searchEngine && <Box mt={2} sx={{ marginTop: '16px', width: '100%', marginBottom: '16px' }}>
                                        <TextField
                                            select
                                            label="Search Engine"
                                            value={searchEngine}
                                            onChange={(e) => {
                                                setSearchEngine(e.target.value);
                                                setSearchSettingsHasChanges(true);
                                            }}
                                            fullWidth={true}
                                            variant="outlined"
                                            SelectProps={{
                                                renderValue: (selected) => (
                                                    <Box display="flex" key={selected}>
                                                        {selected === 'IndexedDB' ? 'IndexedDB' : 'OpenSearch'}
                                                    </Box>
                                                )
                                            }}
                                        >
                                            <MenuItem key={'IndexedDB'} value={'IndexedDB'}>
                                                IndexedDB - In-browser data storage and search
                                            </MenuItem>
                                            <MenuItem key={'openSearch'} value={'openSearch'} disabled={true}>
                                                OpenSearch - Serverless distributed search and analytics engine ( coming soon )
                                            </MenuItem>
                                        </TextField>
                                    </Box>}

                                    {embeddingModel && <Box mt={2} sx={{ marginTop: '16px', width: '100%', marginBottom: '16px' }}>
                                        <TextField
                                            select
                                            label="Embedding Model"
                                            value={embeddingModel || ''}
                                            onChange={(model) => {
                                                setEmbeddingModel(model?.target?.value)
                                                setSearchSettingsHasChanges(true);
                                            }}
                                            fullWidth={true}
                                            variant="outlined"
                                            SelectProps={{
                                                renderValue: (selected) => (
                                                    <Box display="flex" key={EmbeddingModels[selected]?.name}>
                                                        {EmbeddingModels[selected]?.name || 'None'}
                                                    </Box>
                                                )
                                            }}
                                        >
                                            {Object.keys(EmbeddingModels).map((key) => (
                                                <MenuItem key={key} value={key}>
                                                    {EmbeddingModels[key].name}
                                                </MenuItem>
                                            ))}
                                            {embeddingConfigured && <MenuItem key={'none'} value={'none'}>
                                                None
                                            </MenuItem>}
                                        </TextField>
                                    </Box>}


                                    {embeddingDimension && <Box mt={2} sx={{ marginTop: '16px', width: '100%', marginBottom: '16px' }}>
                                        <TextField
                                            select
                                            label="Embedding Dimensions"
                                            value={embeddingDimension || ''}
                                            onChange={(model) => {
                                                setEmbeddingDimension(model?.target?.value)
                                                setSearchSettingsHasChanges(true);
                                            }}
                                            fullWidth={true}
                                            variant="outlined"
                                            SelectProps={{
                                                renderValue: (selected) => (
                                                    <Box display="flex" key={selected}>
                                                        {selected}
                                                    </Box>
                                                )
                                            }}
                                        >
                                            {EmbeddingDimensions.map((key) => (
                                                <MenuItem key={key} value={key}>
                                                    {key}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Box>}

                                    {/* END OF EMBEDDINGS */}

                                    <div style={{textAlign: 'left', marginTop: '16px'}}>
                                        <Button
                                            style={mobileButton}
                                            component="label"
                                            variant="outlined"
                                            startIcon={<UploadFileIcon/>}
                                            sx={{marginRight: 0, marginLeft: 0}}
                                        >
                                            Upload App Icon
                                            <input type="file" accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.gif,.GIF" hidden
                                                   onChange={handleFileUpload}/>
                                        </Button>

                                        {!fileData.length && kbId && <KBImageComponent
                                            style={{marginTop: 10}}
                                            width={isMobile ? '100%' : '250px'}
                                            height={isMobile ? '100%' : '250px'}
                                            id={kbId} noDefault />}

                                        {!!fileData.length && <KBImageComponent
                                            style={{marginTop: 10}}
                                            width={isMobile ? '100%' : '250px'}
                                            height={isMobile ? '100%' : '250px'}
                                            fileData={fileData} noDefault />}
                                    </div>
                                </Box>
                            </PaperWrapper>
                            <Tooltip title={!KBData?.kbTitle ? `Please fill in an ${KBName} Title first` : ''} placement={'bottom-end'} >
                                <Box mt={0} display="flex" justifyContent="flex-end">
                                    {(activeTab === KB_TABS.configuration || newKB) && <Button type="submit"
                                        label={'asdasdas'}
                                        variant={'contained'}
                                        disabled={!KBData?.kbTitle}
                                        color="secondary"
                                        ref={buttonSubmitRef}
                                        onClick={handleUpdateCreateKB}
                                        style={{...mobileButton, marginTop: buttonVerticalMargin}}
                                    >
                                        {kbId ? 'Save' : 'Create'}
                                    </Button>}
                                </Box>
                            </Tooltip>

                        </form>)}
                </Box>}

                {KB_TABS.items && (kbId && !importOpen) && [KB_TABS.items].includes(activeTab) &&
                    <>
                        <List kbTitle={KBData.kbTitle} activeTab={activeTab} kbIdAsSubdomain={kbIdAsSubdomain}
                              setKBData={setKBData} KBData={KBData} setImportOpen={setImportOpen}
                        />
                    </>}

                {activeTab === KB_TABS.chat && kbIdAsSubdomain && <Chat {...{
                    notificationsPermissionStatus, setNotificationsPermissionStatus,
                    open, setUnreadMessages, setKBKeyIsSet, kbIdAsSubdomain, KBData, setKBData, chatId, navigateToChat,
                    kbChats, setKBChats, isStreaming, setIsStreaming, renderSettings, setRenderSettings,
                    dynamicRenderLoaded, setDynamicRenderLoaded, contentRenderLoaded, ChatData, setChatData
                }} />}

            </Container>
        </>
    );
};

export default KBForm;
